Vue.component("create-asset-group", {
    props: ["groupTypes"],
    data () {
        return {
            form: new AppForm({})
        };
    },
    methods: {
        create () {
            App.post("/assets/groups/create", this.form)
            .then(() => {
                this.form = new AppForm({});
                Bus.$emit("asset-group-created");
                window.toastr.success(app.lang.assetGroupName + " created!");
            });
        }
    }
});
